import * as browser from "webextension-polyfill";
const userIdStorageKey = "userid";
let userIdPromise = null;
export function getUserId() {
    if (userIdPromise) {
        return userIdPromise;
    }
    userIdPromise = (async () => {
        const response = await browser.storage.local.get(userIdStorageKey);
        const value = response[userIdStorageKey];
        if (value) {
            return String(value);
        }
        const timeSuffix = (Date.now() % 1e8).toString().padStart(8, "0");
        const alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
        const result = [];
        for (let i = 0; i < 8; i++) {
            const choice = Math.floor(Math.random() * alphabet.length);
            result.push(alphabet[choice]);
        }
        const newUserId = result.join("") + timeSuffix;
        await browser.storage.local.set({ [userIdStorageKey]: newUserId });
        return newUserId;
    })();
    return userIdPromise;
}
